import React from "react"
import {
  BadgeElement,
  BadgeElementType,
  BadgeShapeData,
} from "sharedTypes/badge"
import { EDITOR_RESOLUTION } from "../utils/constants"
import ShapeSVGWrapper, { getShapeStrokeProps } from "./ShapeSVGWrapper"

type Props = {
  element: BadgeElement
  scaleFactor?: number
}

const BadgeOval = ({
  element,
  scaleFactor = EDITOR_RESOLUTION,
}: Props) => {
  if (element.type !== BadgeElementType.OVAL) return null

  const data = element.data as BadgeShapeData
  const thicknessPx = data.thickness * scaleFactor

  const centerX = (element.width * scaleFactor) / 2
  const centerY = (element.height * scaleFactor) / 2
  const radiusX = (element.width * scaleFactor - thicknessPx) / 2
  const radiusY = (element.height * scaleFactor - thicknessPx) / 2

  return (
    <ShapeSVGWrapper width={element.width} height={element.height} scaleFactor={scaleFactor}>
      <ellipse
        cx={centerX}
        cy={centerY}
        rx={radiusX}
        ry={radiusY}
        {...getShapeStrokeProps(data, thicknessPx)}
      />
    </ShapeSVGWrapper>
  )
}

export default BadgeOval
